(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3636],{

/***/ 42512:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/press-room",
      function () {
        return __webpack_require__(85737);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 98350:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/download-icon.722784f4.svg","height":21,"width":19});

/***/ }),

/***/ 19747:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q3": function() { return /* binding */ handleViewDataLayer; },
/* harmony export */   "pV": function() { return /* binding */ pressKitDataLayer; },
/* harmony export */   "rk": function() { return /* binding */ getTabContentEventInfo; },
/* harmony export */   "wQ": function() { return /* binding */ getEventInfo; },
/* harmony export */   "y": function() { return /* binding */ handleContactDataLayer; }
/* harmony export */ });
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27514);

const getEventInfo = (pressReleaseInfo, type, linkName)=>{
    const internalLinkName = linkName || type;
    var ref;
    return JSON.stringify({
        eventAction: "press room:press releases:".concat(type),
        eventName: "press room:press releases:".concat(type),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName,
        internalLinkPosition: "press room",
        internalLinkType: "press room:".concat(pressReleaseInfo["navTitle_s"] ? (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .sanitizeText */ .oOy)(pressReleaseInfo["navTitle_s"]) : ""),
        internalLinkZoneName: "press room:press releases:main content area",
        internalLinkURL: linkName === "download" ? "n/a" : "".concat((ref = pressReleaseInfo["url_s"]) !== null && ref !== void 0 ? ref : "#"),
        clickInternalLinks: "true"
    });
};
const getTabContentEventInfo = function(linkName, type, linkType, analyticsLabel) {
    let url = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null, zone = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : null;
    let zoneName;
    switch(type){
        case "email id":
            zoneName = linkType;
            break;
        case "share":
            zoneName = "contact";
            break;
        default:
            zoneName = zone !== null && zone !== void 0 ? zone : "contacts";
    }
    let internalLinkURL;
    switch(type){
        case "contact number":
            internalLinkURL = "tel:".concat((0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .sanitizeDOMString */ .TRt)(url).replace("\n", ""));
            break;
        default:
            internalLinkURL = "n/a";
    }
    return JSON.stringify({
        eventAction: "press room:".concat(analyticsLabel, ":").concat(type),
        eventName: "press room:".concat(analyticsLabel, ":").concat(type),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .sanitizeTextForAnalytics */ .T68)(linkName),
        internalLinkPosition: "press room",
        internalLinkType: "press room:".concat(linkType),
        internalLinkZoneName: "press room:".concat(analyticsLabel, ":").concat(zoneName),
        internalLinkURL,
        clickInternalLinks: "true"
    });
};
const handleContactDataLayer = (analyticsLabel)=>{
    return JSON.stringify({
        eventAction: "press room:".concat(analyticsLabel, ":print"),
        eventName: "press room:".concat(analyticsLabel, ":print"),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "print",
        internalLinkPosition: "press room",
        internalLinkType: "press room:print",
        internalLinkZoneName: "press room:".concat(analyticsLabel, ":contacts"),
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    });
};
const handleViewDataLayer = (analyticsLabel)=>{
    return JSON.stringify({
        eventAction: "press room:p".concat(analyticsLabel, ":view more"),
        eventName: "press room:p".concat(analyticsLabel, ":view more"),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "view more",
        internalLinkPosition: "press room",
        internalLinkType: "press room:view more",
        internalLinkZoneName: "press room:".concat(analyticsLabel, ":contacts"),
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    });
};
const pressKitDataLayer = (pressKitInfo)=>{
    return JSON.stringify({
        eventAction: "press room:press kits:view press kit link",
        eventName: "press room:press kits:view press kit link",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "view press kit",
        internalLinkPosition: "press room",
        internalLinkType: "press room:".concat(pressKitInfo["navTitle_s"] || ""),
        internalLinkZoneName: "press room:press kits:main content area",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    });
};


/***/ }),

/***/ 1983:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_core_Collapsible__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73394);
/* harmony import */ var _public_icons_arrow_up_svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97274);
/* harmony import */ var _public_icons_arrow_down_svg__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32873);
/* harmony import */ var _utils_index__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(20558);
/* harmony import */ var _components_core_Accordion_Accordion_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(48162);
/* harmony import */ var _components_core_Accordion_Accordion_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_components_core_Accordion_Accordion_module_scss__WEBPACK_IMPORTED_MODULE_6__);







const Accordion = (props)=>{
    const { isOpen =false , analyticTitleData , analyticTitleCustomData , contentOverflow =false , trigger =false , children ="" , title , handleOpen , handleClose , containerElementProps , isArrow =false  } = props;
    const accordionWrapperStyle = "".concat((_components_core_Accordion_Accordion_module_scss__WEBPACK_IMPORTED_MODULE_6___default().accordionWrapper), " accordion-container");
    const CollapsibleHeader = (param)=>/*#__PURE__*/ {
        let { title  } = param;
        return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "collapsible__header ".concat(analyticTitleData ? "gbh-data-layer" : ""),
            "data-gbh-data-layer": analyticTitleData || null,
            "data-gbh-data-layer-custom": analyticTitleCustomData || null,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    role: "heading",
                    "aria-level": "5",
                    children: title
                }),
                !isArrow ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "plus",
                    "aria-hidden": true,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "line line-1"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "line line-2"
                        })
                    ]
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "arrow",
                    "aria-hidden": true,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "down-arrow",
                            children: [
                                " ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    src: _public_icons_arrow_down_svg__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z,
                                    alt: "Arrow Down"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "up-arrow",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: _public_icons_arrow_up_svg__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z,
                                alt: "Arrow Up"
                            })
                        })
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: accordionWrapperStyle,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "collapsible-accordion",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_core_Collapsible__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                open: isOpen,
                onTriggerOpening: handleOpen,
                onTriggerClosing: handleClose,
                containerElementProps: containerElementProps,
                overflowWhenOpen: contentOverflow ? contentOverflow : "hidden",
                openedClassName: "collapsible--open",
                tabIndex: "0",
                triggerOpenedClassName: "collapsible__trigger--open",
                trigger: trigger ? trigger : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CollapsibleHeader, {
                    title: title
                }),
                transitionTime: 400,
                easing: "ease-in-out",
                triggerElementProps: {
                    id: (0,_utils_index__WEBPACK_IMPORTED_MODULE_5__/* .accordionUniqueId */ .M0)("collapsible-trigger", 9999, 1000)
                },
                contentElementId: (0,_utils_index__WEBPACK_IMPORTED_MODULE_5__/* .accordionUniqueId */ .M0)("collapsible-content", 9999, 1000),
                children: children
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Accordion);


/***/ }),

/***/ 85737:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ press_room; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/AemGrid.jsx + 113 modules
var AemGrid = __webpack_require__(73661);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(27514);
// EXTERNAL MODULE: ./components/Shared/GlobalPage/GlobalPageHeader.jsx + 31 modules
var GlobalPageHeader = __webpack_require__(82660);
// EXTERNAL MODULE: ./components/Shared/GlobalPage/GlobalPageFooter.jsx
var GlobalPageFooter = __webpack_require__(10884);
// EXTERNAL MODULE: ./src/components/Shared/GlobalPage/GlobalPageLayout.jsx
var GlobalPageLayout = __webpack_require__(82706);
// EXTERNAL MODULE: ./store/features/genericSlice.js
var genericSlice = __webpack_require__(88751);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(85518);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 18 modules
var esm = __webpack_require__(72433);
;// CONCATENATED MODULE: ./src/i18n/usePressLandingi18n.js

const usePressLandingi18n = (param)=>{
    let { authorData  } = param;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const i18n = {
        title: t("kf.PressRoom.label.title"),
        description: t("kf.PressRoom.label.description"),
        pressContact: t("kf.PressRoom.label.pressContact"),
        productPlacement: t("kf.PressRoom.label.productPlacement"),
        contact1Name: t("kf.PressRoom.label.contact1Name"),
        contact1Email: t("kf.PressRoom.label.contact1Email"),
        contact1Mobile: t("kf.PressRoom.label.contact1Mobile"),
        contact2Name: t("kf.PressRoom.label.contact2Name"),
        contact2Email: t("kf.PressRoom.label.contact2Email"),
        contact2Mobile: t("kf.PressRoom.label.contact2Mobile"),
        productContact1Name: t("kf.PressRoom.label.productContact1Name"),
        productContact1Email: t("kf.PressRoom.label.productContact1Email"),
        productContact1Mobile: t("kf.PressRoom.label.productContact1Mobile"),
        productContact2Name: t("kf.PressRoom.label.productContact2Name"),
        productContact2Email: t("kf.PressRoom.label.productContact2Email"),
        productContact2Mobile: t("kf.PressRoom.label.productContact2Mobile"),
        print: t("kf.plp.label.print"),
        share: t("kf.plp.label.share"),
        sort: t("kf.plp.label.sort"),
        sortbyExpanded: t("kf.plp.label.sortbyExpanded"),
        sortbyClosed: t("kf.plp.label.sortbyClosed"),
        selected: t("kf.plp.arialabel.selected"),
        altSort: t("kf.plp.label.img.altSort"),
        date: t("kf.PressRoom.label.date"),
        pressKitTitle: t("kf.PressRoom.label.pressKitTitle"),
        description1: t("kf.PressRoom.label.description1"),
        viewPressKit: t("kf.PressRoom.label.viewPressKit"),
        externalLink: t("kf.PressRoom.label.externalLink"),
        accordianDetails: t("kf.PressRoom.label.accordianDetails"),
        downloadPdf: t("kf.PressRoom.label.downloadPdf"),
        pressReleaseTitle: t("kf.PressRoom.label.pressReleaseTitle"),
        readMore: t("kf.PressRoom.label.readMore"),
        download: t("kf.PressRoom.label.download"),
        downloading: t("kf.PressRoom.label.downloading"),
        sortByName: t("kf.PressRoom.label.sortByName"),
        sortByAsc: t("kf.PressRoom.label.sortByAsc"),
        sortByDesc: t("kf.PressRoom.label.sortByDesc"),
        sortByNewest: t("kf.PressRoom.label.sortByNewest"),
        sortByOldest: t("kf.PressRoom.label.sortByOldest"),
        pressRelease: t("kf.PressRoom.label.pressRelease"),
        pressKit: t("kf.PressRoom.label.pressKit"),
        imageLibrary: t("kf.PressRoom.label.imageLibrary"),
        cancel: t("kf.button.action.cancel"),
        ok: t("kf.button.action.ok"),
        modalHeading: t("kf.PressRoom.label.modalHeading"),
        modalContent: t("kf.PressRoom.label.modalContent"),
        viewMore: t("kf.PressRoom.label.viewMore"),
        showLess: t("kf.PressRoom.label.showLess"),
        noContacts: t("kf.PressRoom.label.noContacts"),
        noProducts: t("kf.PressRoom.label.noProducts"),
        loadMore: t("kf.plp.label.loadMore"),
        view: t("kf.plp.label.view"),
        all: t("kf.plp.label.all"),
        backToTop: t("kf.plp.label.backToTop"),
        items: t("kf.plp.label.items"),
        etc: t("kf.plp.label.etc"),
        sortByAria: (count)=>t("kf.plp.label.sortByAria", {
                sortByCount: count
            }),
        ariaLabel: {
            downloadPdf: (title)=>t("kf.PressRoom.aria.label.downloadPdf", {
                    title
                }),
            loadMore: t("kf.pressRoom.aria.label.loadMore"),
            email: (email, name)=>t("kf.pressRoom.aria.label.email", {
                    email,
                    name
                }),
            phone: (phone, name)=>t("kf.pressRoom.aria.label.phone", {
                    phone,
                    name
                }),
            viewMore: t("kf.pressRoom.aria.label.viewMore"),
            viewLess: t("kf.pressRoom.aria.label.viewLess"),
            readMore: (title)=>t("kf.PressRoom.aria.label.readMore", {
                    title
                }),
            download: (title)=>t("kf.PressRoom.aria.label.download", {
                    title
                }),
            viewPressKit: (title)=>t("kf.PressRoom.aria.label.viewPressKit", {
                    title
                }),
            externalLink: t("kf.PressRoom.aria.label.externalLink")
        },
        downloadComplete: t("kf.PressRoom.label.downloadComplete"),
        complete: t("kf.PressRoom.label.complete"),
        downloadSuccess: t("kf.PressRoom.label.downloadSuccess"),
        downloadFailure: t("kf.PressRoom.label.downloadFailure")
    };
    return i18n;
};
/* harmony default export */ var i18n_usePressLandingi18n = (usePressLandingi18n);

// EXTERNAL MODULE: ./components/SocialShare/v1/SocialShare.jsx + 1 modules
var SocialShare = __webpack_require__(24636);
// EXTERNAL MODULE: ./public/icons/print.svg
var icons_print = __webpack_require__(30402);
// EXTERNAL MODULE: ./public/icons/share.svg
var icons_share = __webpack_require__(66773);
// EXTERNAL MODULE: ./src/components/PressRoomLanding/v1/pressRoomAnalytics.js
var pressRoomAnalytics = __webpack_require__(19747);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./components/PressRoomLanding/v1/TabContent/index.jsx









const TabContent = (param)=>{
    let { analyticsLabel ="" , i18n ={} , pressContact =[] , productPlacement =[] , tabData ={}  } = param;
    const contactRef = (0,react.useRef)(null);
    const contactRef1 = (0,react.useRef)(null);
    const sortBtn = (0,react.useRef)(null);
    const shareImg = (0,react.useRef)(null);
    const [showSocialLink, setShowSocialLink] = (0,react.useState)(false);
    const [contactList, setContactList] = (0,react.useState)([]);
    const [placementList, setPlacementList] = (0,react.useState)([]);
    const [viewContactList, setViewContactList] = (0,react.useState)(false);
    const [hideContactList, setHideContactList] = (0,react.useState)(false);
    const [viewPlacementList, setViewPlacementList] = (0,react.useState)(false);
    const [hidePlacementList, setHidePlacementList] = (0,react.useState)(false);
    const router = (0,next_router.useRouter)();
    (0,react.useEffect)(()=>{
        if (!showSocialLink) {
            var ref;
            (ref = sortBtn.current) === null || ref === void 0 ? void 0 : ref.focus();
        }
    }, [
        showSocialLink
    ]);
    (0,react.useEffect)(()=>{
        const pressContactSize = pressContact.length > 5 ? 3 : pressContact.length === 5 ? pressContact.length - 2 : 3;
        handleContactList(pressContactSize);
        if (pressContact.length > 3) setViewContactList(true);
    }, [
        pressContact
    ]);
    (0,react.useEffect)(()=>{
        const pressContactSize = productPlacement.length > 5 ? 3 : productPlacement.length === 5 ? productPlacement.length - 2 : 3;
        handlePlacementList(pressContactSize);
        if (productPlacement.length > 3) setViewPlacementList(true);
    }, [
        productPlacement
    ]);
    const handleContactList = (pressContactSize)=>{
        if (pressContact.length > 0) {
            const list = [];
            pressContact.forEach((item, i)=>{
                if (i < pressContactSize) {
                    list.push(item);
                }
            });
            setContactList(list);
        }
    };
    const handlePlacementList = (pressContactSize)=>{
        if (productPlacement.length > 0) {
            const list = [];
            productPlacement.forEach((item, i)=>{
                if (i < pressContactSize) {
                    list.push(item);
                }
            });
            setPlacementList(list);
        }
    };
    (0,react.useEffect)(()=>{
        if (placementList.length > 0) {
            if (contactRef.current) {
                const links = contactRef.current.querySelectorAll("a");
                links.forEach((link, i)=>{
                    var ref, ref1;
                    link.classList.add("gbh-data-layer");
                    var _i;
                    const item = (_i = contactList[i]) !== null && _i !== void 0 ? _i : {};
                    link.setAttribute("data-gbh-data-layer", (0,pressRoomAnalytics/* getTabContentEventInfo */.rk)(item === null || item === void 0 ? void 0 : item.phone, "contact number", item === null || item === void 0 ? void 0 : (ref = item.name) === null || ref === void 0 ? void 0 : ref.toLowerCase(), analyticsLabel, item === null || item === void 0 ? void 0 : item.phone, i18n === null || i18n === void 0 ? void 0 : (ref1 = i18n.pressContact) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()));
                });
            }
            if (contactRef1.current) {
                const links1 = contactRef1.current.querySelectorAll("a");
                links1.forEach((link, i)=>{
                    var ref, ref1;
                    link.classList.add("gbh-data-layer");
                    var _i;
                    const item = (_i = placementList[i]) !== null && _i !== void 0 ? _i : {};
                    link.setAttribute("data-gbh-data-layer", (0,pressRoomAnalytics/* getTabContentEventInfo */.rk)(item === null || item === void 0 ? void 0 : item.phone, "contact number", item === null || item === void 0 ? void 0 : (ref = item.name) === null || ref === void 0 ? void 0 : ref.toLowerCase(), analyticsLabel, item === null || item === void 0 ? void 0 : item.phone, i18n === null || i18n === void 0 ? void 0 : (ref1 = i18n.productPlacement) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()));
                });
            }
        }
    }, [
        analyticsLabel,
        placementList,
        contactList
    ]);
    const handleContactListView = (show)=>{
        if (show) {
            handleContactList(5);
            setViewContactList(false);
            setHideContactList(true);
        } else {
            handleContactList(3);
            setHideContactList(false);
            setViewContactList(true);
        }
    };
    const handlePlacementListView = (show)=>{
        if (show) {
            handlePlacementList(5);
            setViewPlacementList(false);
            setHidePlacementList(true);
        } else {
            handlePlacementList(3);
            setHidePlacementList(false);
            setViewPlacementList(true);
        }
    };
    const handlePrint = ()=>{
        window.print();
    };
    const { ariaLabel: { email =()=>{}  } , noContacts ="" , viewMore ="" , showLess ="" , noProducts ="" , print ="" , share =""  } = i18n;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "container kf-react-container press-room__tab-full-content",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "row",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "col-12 press-room__inner-container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("aside", {
                        className: "press-room__side_pannel",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "press-room__contact",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: "press-room__contact_title",
                                        children: i18n.pressContact
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "press-room__divider"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                        role: "group",
                                        "aria-label": pressContact,
                                        children: contactList.length > 0 && contactList.map((item, i)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "press-room__contact_item",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "press-room__contact_name",
                                                        children: item.name
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: "mailto:".concat(item.email),
                                                        "aria-label": email(item.email, item.name),
                                                        "data-gbh-data-layer": (0,pressRoomAnalytics/* getEventInfo */.wQ)("mailto:".concat(item.email), "email id", "press contact"),
                                                        className: "press-room__contact_email gbh-data-layer",
                                                        children: item.email
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        tabIndex: "0",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: "tel:".concat(item.phone),
                                                            className: "press-room__contact_mobile gbh-data-layer",
                                                            "data-gbh-data-layer": (0,pressRoomAnalytics/* getEventInfo */.wQ)("".concat(item.phone), "contact number", "".concat(item.name.toLowerCase()), "".concat(item.phone), "".concat(pressContact)),
                                                            children: (0,helper/* sanitizeInnerHtml */.KD0)(item.phone)
                                                        })
                                                    })
                                                ]
                                            }, i))
                                    }),
                                    contactList.length === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "press-room__contact_item",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "press-room__contact_name",
                                            children: noContacts
                                        })
                                    }),
                                    viewContactList && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "press-room__view_more --button gbh-data-layer",
                                        tabIndex: "0",
                                        "data-gbh-data-layer": (0,pressRoomAnalytics/* handleViewDataLayer */.Q3)(analyticsLabel),
                                        onClick: ()=>handleContactListView(true),
                                        children: viewMore
                                    }),
                                    hideContactList && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "press-room__view_more --button gbh-data-layer",
                                        tabIndex: "0",
                                        "data-gbh-data-layer": (0,pressRoomAnalytics/* handleContactDataLayer */.y)(analyticsLabel),
                                        onClick: ()=>handleContactListView(false),
                                        children: showLess
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "press-room__placement",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: "press-room__contact_title",
                                        children: i18n.productPlacement
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "press-room__divider"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                        role: "group",
                                        "aria-label": i18n.productPlacement,
                                        children: placementList.length > 0 && placementList.map((item, i)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "press-room__contact_item",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "press-room__contact_name",
                                                        children: item.name
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: "mailto:".concat(item.email),
                                                        "aria-label": email(item.email, item.name),
                                                        "data-gbh-data-layer": (0,pressRoomAnalytics/* getEventInfo */.wQ)("mailto:".concat(item.email), "email id", "product placement"),
                                                        className: "press-room__contact_email gbh-data-layer",
                                                        children: item.email
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        tabIndex: "0",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: "tel:".concat(item.phone),
                                                            className: "press-room__contact_mobile gbh-data-layer",
                                                            "data-gbh-data-layer": (0,pressRoomAnalytics/* getEventInfo */.wQ)("".concat(item.phone), "contact number", "".concat(item.name.toLowerCase()), "".concat(item.phone), "Product Placement"),
                                                            children: (0,helper/* sanitizeInnerHtml */.KD0)(item.phone)
                                                        })
                                                    })
                                                ]
                                            }, i))
                                    }),
                                    placementList.length === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "press-room__contact_item",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "press-room__contact_name",
                                            children: noProducts
                                        })
                                    }),
                                    viewPlacementList && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "press-room__view_more --button",
                                        onClick: ()=>handlePlacementListView(true),
                                        children: viewMore
                                    }),
                                    hidePlacementList && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "press-room__view_more --button",
                                        onClick: ()=>handlePlacementListView(false),
                                        children: showLess
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "press-room__contact-button-block",
                                        role: "presentation",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                tabIndex: "0",
                                                className: "press-room__print-block gbh-data-layer",
                                                role: "button",
                                                "aria-label": print,
                                                "data-gbh-data-layer": (0,pressRoomAnalytics/* handleContactDataLayer */.y)(analyticsLabel),
                                                onClick: handlePrint,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        "aria-hidden": true,
                                                        className: "press-room__print-icon",
                                                        src: icons_print/* default */.Z === null || icons_print/* default */.Z === void 0 ? void 0 : icons_print/* default.src */.Z.src
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        "aria-hidden": true,
                                                        className: "press-room__print",
                                                        children: print
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "press-room__share-block",
                                                tabIndex: "0",
                                                onClick: ()=>setShowSocialLink(!showSocialLink),
                                                role: "button",
                                                "aria-label": share,
                                                ref: shareImg,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        "aria-hidden": true,
                                                        className: "press-room__share-icon",
                                                        src: icons_share/* default */.Z === null || icons_share/* default */.Z === void 0 ? void 0 : icons_share/* default.src */.Z.src
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        "aria-hidden": true,
                                                        className: "press-room__share gbh-data-layer",
                                                        "data-gbh-data-layer": (0,pressRoomAnalytics/* getTabContentEventInfo */.rk)("share", "share", "share", analyticsLabel),
                                                        children: share
                                                    })
                                                ]
                                            }),
                                            showSocialLink ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialShare/* default */.Z, {
                                                analyticData: {
                                                    eventAction: "press room:".concat(analyticsLabel, ":share"),
                                                    eventName: "press room:".concat(analyticsLabel, ":share"),
                                                    internalLinkPosition: "press room",
                                                    internalLinkType: "press room:share",
                                                    internalLinkZoneName: "press room:".concat(analyticsLabel, ":product placement")
                                                },
                                                showModal: showSocialLink,
                                                id: "kf-press-release",
                                                onClose: ()=>{
                                                    setShowSocialLink(false);
                                                    shareImg === null || shareImg === void 0 ? void 0 : shareImg.current.focus();
                                                },
                                                shareBtn: shareImg,
                                                url: "".concat(window.location.origin).concat(router === null || router === void 0 ? void 0 : router.asPath)
                                            }) : null
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "press-room__main_pannel",
                        children: tabData
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var v1_TabContent = (TabContent);

// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./constants/config.js
var config = __webpack_require__(19514);
;// CONCATENATED MODULE: ./src/components/PressRoomLanding/v1/TabComponent/index.jsx






const TabComponent = (param)=>{
    let { tabList =[] , refData ={}  } = param;
    const [activeTab, setActiveTab] = (0,react.useState)(0);
    const [showModal, setShowModal] = (0,react.useState)(false);
    const [prevTab, setPrevTab] = (0,react.useState)(0);
    const [updatedTabList, setUpdatedTabList] = (0,react.useState)([]);
    const [brandName, setBrandName] = (0,react.useState)({});
    const router = (0,next_router.useRouter)();
    (0,react.useEffect)(()=>{
        (0,config/* getConfig */.i)().then((CONFIG)=>{
            var ref;
            var ref1;
            setBrandName((ref1 = (ref = CONFIG.general) === null || ref === void 0 ? void 0 : ref.siteName) !== null && ref1 !== void 0 ? ref1 : "");
        });
    }, []);
    (0,react.useEffect)(()=>{
        const { query  } = router;
        const activeSortIndex = query === null || query === void 0 ? void 0 : query.activeTab;
        if (activeSortIndex !== null && activeSortIndex !== undefined) {
            setActiveTab(Number(activeSortIndex));
        }
    }, []);
    (0,react.useEffect)(()=>{
        if (showModal && get_default()(tabList[activeTab], "url", "")) {
            var ref;
            window.handleShowModal((ref = tabList[activeTab]) === null || ref === void 0 ? void 0 : ref.url);
        }
    }, [
        showModal
    ]);
    (0,react.useEffect)(()=>{
        if (brandName !== "kohler" && tabList.length > 0) {
            const tabTempData = tabList.filter((tabDetails)=>tabDetails["title"] && tabDetails["title"].toLowerCase() !== "image library");
            setUpdatedTabList(tabTempData);
        }
    }, [
        tabList,
        brandName
    ]);
    const changeTab = (tab)=>{
        if (get_default()(tabList[tab], "url", "")) {
            if (showModal) {
                setActiveTab(prevTab);
                setShowModal(false);
                document.getElementById("".concat(tabList[prevTab].title, "-tab")).focus();
                return;
            }
            setPrevTab(activeTab);
            setShowModal(true);
        }
        setActiveTab(tab);
        (0,helper/* replaceSearchUrl */.CjH)("activeTab", tab);
    };
    const handleKeyPress = (e)=>{
        if (e.keyCode === 37 || e.keyCode === 39) {
            var ref;
            let tab;
            if (e.keyCode === 37) {
                tab = activeTab - 1;
            } else if (e.keyCode === 39) {
                tab = activeTab + 1;
            }
            if (tab < 0) tab = tabList.length - 1;
            if (tab >= tabList.length) tab = 0;
            (ref = document.getElementById("".concat(tabList[tab].title, "-tab"))) === null || ref === void 0 ? void 0 : ref.focus();
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "press-room__tab-header",
                role: "tablist",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container kf-react-container press-room__tab-buttons",
                    children: updatedTabList.map((tab, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: "press-room__tab-button gbh-data-layer ".concat(activeTab === i ? "--active" : ""),
                            "data-gbh-data-layer": '{"eventAction":"press room:'.concat(tab.title.toLowerCase(), ' tab","eventName":"press room:').concat(tab.title.toLowerCase(), ' tab","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"').concat(tab.title.toLowerCase(), '","internalLinkPosition":"press room","internalLinkType":"press room:navigation","internalLinkZoneName":"press room:hero banner","internalLinkURL":"n/a","clickInternalLinks":"true"}'),
                            role: "tab",
                            tabIndex: tabList[activeTab].title === tab.title ? 0 : -1,
                            "aria-controls": "".concat(tab.title, "-panel"),
                            id: "".concat(tab.title, "-tab"),
                            onClick: ()=>changeTab(i),
                            onFocus: ()=>changeTab(i),
                            onKeyDown: (e)=>handleKeyPress(e),
                            ref: activeTab === i ? refData : null,
                            children: "".concat(tab.title)
                        }, i))
                })
            }),
            get_default()(tabList[activeTab], "content", "") && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "press-room__tab-content",
                id: "".concat(tabList[activeTab].title, "-panel"),
                "aria-labelledby": "".concat(tabList[activeTab].title, "-tab"),
                children: get_default()(tabList[activeTab], "content", "")
            })
        ]
    });
};
/* harmony default export */ var v1_TabComponent = (TabComponent);

// EXTERNAL MODULE: ./components/PressRoomLanding/v1/PressRoomView/index.module.scss
var index_module = __webpack_require__(2681);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./node_modules/react-lazy-load/dist/LazyLoad.js
var LazyLoad = __webpack_require__(25043);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./src/store/features/productListSlice.js
var productListSlice = __webpack_require__(42286);
// EXTERNAL MODULE: ./src/hooks/useWindowResize.js
var useWindowResize = __webpack_require__(18216);
// EXTERNAL MODULE: ./constants/index.js + 2 modules
var constants = __webpack_require__(47956);
// EXTERNAL MODULE: ./src/components/ProductList/v2/ProductListView/Pagination/Pagination.jsx
var Pagination = __webpack_require__(47537);
// EXTERNAL MODULE: ./src/components/ProductList/v2/ProductListView/Pagination/LoadMore.jsx
var LoadMore = __webpack_require__(75455);
// EXTERNAL MODULE: ./src/components/core/Accordion/Accordion.jsx
var Accordion = __webpack_require__(1983);
// EXTERNAL MODULE: ./src/components/ProductList/v2/Sort/index.jsx + 2 modules
var Sort = __webpack_require__(73812);
// EXTERNAL MODULE: ./components/Search/v1/ProductsTab/helper.js
var ProductsTab_helper = __webpack_require__(34955);
// EXTERNAL MODULE: ./components/PressRoomLanding/v1/PressKit.view/index.module.scss
var PressKit_view_index_module = __webpack_require__(7805);
var PressKit_view_index_module_default = /*#__PURE__*/__webpack_require__.n(PressKit_view_index_module);
// EXTERNAL MODULE: ./public/icons/download-icon.svg
var download_icon = __webpack_require__(98350);
// EXTERNAL MODULE: ./public/images/image-missing.png
var image_missing = __webpack_require__(36513);
;// CONCATENATED MODULE: ./public/icons/link-icon.svg
/* harmony default export */ var link_icon = ({"src":"/_next/static/media/link-icon.7c764d94.svg","height":19,"width":19});
;// CONCATENATED MODULE: ./components/PressRoomLanding/v1/PressKit.view/index.jsx




















const PressRelease = (param)=>{
    let { i18n ={} , refData ={}  } = param;
    const [width] = (0,useWindowResize/* default */.Z)();
    const [curRows, setCurRows] = (0,react.useState)(30);
    const [selectedSort, setSelectedSort] = (0,react.useState)({
        name: (0,helper/* getAppliedSortPressKit */.fnA)(i18n, "pressReleaseDate_dt+desc"),
        query: "pressReleaseDate_dt+desc"
    });
    const [filterQueries, setFilterQueries] = (0,react.useState)([]);
    const [start, setStart] = (0,react.useState)(0);
    const [isOpen, setIsOpen] = (0,react.useState)(false);
    const [formatedDate, setformatedDate] = (0,react.useState)([]);
    const [dataPopulated, setDataPopulated] = (0,react.useState)(false);
    const [kitData, setKitData] = (0,react.useState)([]);
    const [totalResults, setTotalResults] = (0,react.useState)(0);
    const dispatch = (0,es/* useDispatch */.I0)();
    const [lwAppName, setLwAppName] = (0,react.useState)("");
    const isAcordianOpen = true;
    const { sortByAsc ="" , sortByDesc ="" , sortByNewest ="" , sortByOldest ="" , viewPressKit ="" , externalLink ="" , accordianDetails ="" , downloadPdf ="" , ariaLabel ={}  } = i18n;
    const sorts = [
        {
            name: sortByAsc,
            query: "navTitle_s+asc"
        },
        {
            name: sortByDesc,
            query: "navTitle_s+desc"
        },
        {
            name: sortByNewest,
            query: "pressReleaseDate_dt+desc"
        },
        {
            name: sortByOldest,
            query: "pressReleaseDate_dt+asc"
        }
    ];
    (0,react.useEffect)(()=>{
        const configFn = async ()=>{
            const { general  } = await (0,config/* getConfig */.i)();
            var ref;
            setLwAppName((ref = general === null || general === void 0 ? void 0 : general.lwAppName) !== null && ref !== void 0 ? ref : "");
        };
        configFn();
    }, []);
    (0,react.useEffect)(()=>{
        const formattedSort = (0,helper/* sortParameterURL */.zIK)();
        if (formattedSort) {
            setSelectedSort({
                name: (0,helper/* getAppliedSortPressKit */.fnA)(i18n, formattedSort),
                query: formattedSort
            });
        }
    }, []);
    (0,react.useEffect)(()=>{
        if (lwAppName) {
            if (start) {
                generateListingUrl(true, false);
            } else if (start == 0 && curRows) {
                generateListingUrl(false, false);
            } else {
                generateListingUrl();
            }
        }
    }, [
        start,
        curRows,
        selectedSort,
        lwAppName
    ]);
    (0,react.useEffect)(()=>{
        // To scrollup the product list on back
        if (dataPopulated) (0,ProductsTab_helper/* scrollToProduct */.C1)();
    }, [
        dataPopulated
    ]);
    (0,react.useEffect)(()=>{
        const formatPressReleaseDates = kitData.map((pressKitInfo)=>{
            if (pressKitInfo && pressKitInfo["pressReleaseDate_dt"]) {
                return (0,helper/* formatDate */.p6d)(pressKitInfo["pressReleaseDate_dt"]).then((formattedDate)=>({
                        ...pressKitInfo,
                        formattedDate: formattedDate
                    })).catch(()=>pressKitInfo);
            }
            return Promise.resolve(pressKitInfo);
        });
        Promise.all(formatPressReleaseDates).then((formattedData)=>setformatedDate(formattedData)).catch((err)=>console.log(err));
    }, [
        kitData
    ]);
    const onSort = (selectedSort)=>{
        setStart(0);
        setSelectedSort(selectedSort);
        setIsOpen(false);
        (0,helper/* replaceSearchUrl */.CjH)("sort", selectedSort.query);
    };
    const generateListingUrl = function(update) {
        let enableScroll = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, queries = arguments.length > 2 ? arguments[2] : void 0;
        let callStart = 0;
        if (queries) {
            setFilterQueries(queries);
        } else {
            queries = filterQueries;
            callStart = start;
        }
        const query = {
            rows: curRows,
            start: callStart
        };
        if (selectedSort) query.sort = selectedSort.query;
        const fl = [
            "id",
            "navTitle_s",
            "eyeBrowText_s",
            "page_description_content_s",
            "url_s",
            "jcr_created_s",
            "thumbNailImage_s",
            "pressReleaseDate_dt"
        ];
        const queryParams = {
            q: "*:*",
            fl: fl.join(","),
            ...query,
            displaytype: "search",
            update,
            fq: 'templateName_s:("Press-Kit")',
            profileName: "profile_".concat(lwAppName === null || lwAppName === void 0 ? void 0 : lwAppName.toLowerCase(), "_Search"),
            collections: lwAppName === null || lwAppName === void 0 ? void 0 : lwAppName.toLowerCase()
        };
        if (enableScroll) setDataPopulated(false);
        dispatch((0,productListSlice/* getProducts */.Xp)({
            ...queryParams
        })).unwrap().then((res)=>{
            const { data: { data =[] , total =""  }  } = res;
            if (update) {
                setKitData((prevData)=>[
                        ...prevData,
                        ...data
                    ]);
            } else {
                setKitData(data);
            }
            setTotalResults(total);
            if (enableScroll) setDataPopulated(true);
        }).catch(()=>{
            if (enableScroll) setDataPopulated(false);
        });
    };
    const onRows = (rows)=>{
        setStart(0);
        setCurRows(rows);
    };
    const onLoadMore = ()=>{
        setStart(start + curRows);
    };
    const handleBackToTop = ()=>{
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
        refData.current.focus();
    };
    const handleImgErr = (e)=>{
        return e.target.src = image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src;
    };
    const checkImg = (e, src)=>{
        e.persist();
        const ele = e.target;
        if (ele.src !== (image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src) && ele.src === constants.imgPlaceholderData) {
            axios_default().head(src).then((res)=>{
                if (!res) handleImgErr(e);
            }).catch(()=>handleImgErr(e));
        }
    };
    var ref, ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (PressKit_view_index_module_default()).myKitViewWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "press-kit",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "row press-kit__sort-by-block m-0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-lg-12 col-md-12 col-12 p-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Sort/* default */.Z, {
                            page: "press-kits",
                            data: sorts,
                            texts: i18n,
                            selectedSort: selectedSort,
                            onChange: onSort,
                            isOpen: isOpen,
                            setIsOpen: setIsOpen
                        })
                    })
                }),
                kitData ? kitData === null || kitData === void 0 ? void 0 : kitData.map((pressKitInfo, index)=>{
                    var ref2;
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(LazyLoad/* default */.Z, {
                        className: "kf-lazyload-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "press-kit__row",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "col press-kit__info px-0",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "press-kit__date",
                                            children: pressKitInfo && pressKitInfo["pressReleaseDate_dt"] ? (ref = (ref2 = formatedDate[index]) === null || ref2 === void 0 ? void 0 : ref2.formattedDate) !== null && ref !== void 0 ? ref : "" : ""
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            className: "press-kit__title",
                                            children: pressKitInfo["navTitle_s"] ? pressKitInfo["navTitle_s"] : ""
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "press-kit__description",
                                            children: pressKitInfo ? pressKitInfo["eyeBrowText_s"] : ""
                                        }),
                                        isAcordianOpen === true ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "press-kit__view-kit-icon-block",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                className: "gbh-data-layer",
                                                target: (0,helper/* isUrlIncludeHttp */.l4J)(pressKitInfo["url_s"]) ? "_blank" : "",
                                                rel: "noreferrer",
                                                "aria-label": ariaLabel === null || ariaLabel === void 0 ? void 0 : ariaLabel.viewPressKit(pressKitInfo["navTitle_s"] ? pressKitInfo["navTitle_s"] : ""),
                                                "data-gbh-data-layer": (0,pressRoomAnalytics/* pressKitDataLayer */.pV)(pressKitInfo),
                                                href: (ref1 = pressKitInfo["url_s"]) !== null && ref1 !== void 0 ? ref1 : "#",
                                                children: [
                                                    (0,helper/* isUrlIncludeHttp */.l4J)(pressKitInfo["url_s"]) && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        className: "press-kit__view-kit-icon",
                                                        src: link_icon === null || link_icon === void 0 ? void 0 : link_icon.src,
                                                        alt: viewPressKit
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "press-kit__view-kit-link",
                                                        children: (0,helper/* isUrlIncludeHttp */.l4J)(pressKitInfo["url_s"]) ? externalLink : viewPressKit
                                                    })
                                                ]
                                            })
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "press-kit__view-accordian-icon-block",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Accordion/* default */.Z, {
                                                isOpen: false,
                                                title: viewPressKit,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "press-kit__view-accordian-kit-details",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "press-kit__view-para",
                                                                children: accordianDetails
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "press-kit__download-block",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "press-kit__download-icon-block float-left",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                            className: "press-kit__download-icon",
                                                                            src: download_icon/* default */.Z,
                                                                            alt: downloadPdf
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "press-kit__download-link float-left",
                                                                        children: downloadPdf
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "press-kit__view-accordian-kit-details",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "press-kit__view-para",
                                                                children: accordianDetails
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "press-kit__download-block",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "press-kit__download-icon-block float-left",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                            className: "press-kit__download-icon",
                                                                            src: download_icon/* default */.Z,
                                                                            alt: downloadPdf
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "press-kit__download-link float-left",
                                                                        children: downloadPdf
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "press-kit__view-accordian-kit-details",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "press-kit__view-para",
                                                            children: accordianDetails
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                pressKitInfo ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "press-kit__image",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: pressKitInfo["thumbNailImage_s"],
                                        alt: pressKitInfo["navTitle_s"] ? (0,helper/* sanitizeText */.oOy)(pressKitInfo["navTitle_s"]) : "",
                                        className: "cmp-image__image transition",
                                        onLoad: (e)=>checkImg(e, pressKitInfo["thumbNailImage_s"]),
                                        onError: (e)=>handleImgErr(e)
                                    })
                                }) : null
                            ]
                        })
                    }, pressKitInfo.id);
                }) : null,
                totalResults > curRows && totalResults > kitData.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "product-listing",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadMore/* default */.Z, {
                        displayShare: true,
                        displayPrint: true,
                        staticTexts: i18n,
                        curRows: curRows,
                        productsPerPage: constants.PRODUCTS_PER_PAGE,
                        totalResults: totalResults,
                        onRows: onRows,
                        handleBackToTop: handleBackToTop,
                        page: "press-kit",
                        data: kitData,
                        onLoadMore: onLoadMore,
                        width: width
                    })
                }) : null,
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "press-room__pagination",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination/* default */.Z, {
                        displayShare: true,
                        displayPrint: true,
                        staticTexts: i18n,
                        curRows: curRows,
                        productsPerPage: constants.PRODUCTS_PER_PAGE,
                        totalResults: totalResults,
                        onRows: onRows,
                        handleBackToTop: handleBackToTop,
                        page: "press-kit",
                        data: kitData,
                        onLoadMore: onLoadMore,
                        width: width,
                        customClass: {
                            buttonClass: "product-list__go-back",
                            spanClass: "product-list__go-back-text",
                            imgClass: "product-list__go-back-image"
                        },
                        includeWrapper: false
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var PressKit_view = (PressRelease);

;// CONCATENATED MODULE: ./components/PressRoomLanding/v1/PressRoomView/index.jsx




const PressRoomView_PressRelease = /*#__PURE__*/ (0,react.lazy)(()=>__webpack_require__.e(/* import() */ 8414).then(__webpack_require__.bind(__webpack_require__, 68414)));


const PressRoomView = (param)=>{
    let { i18n ={} , pressContact =[] , title ="" , desc ="" , productPlacement =[] , imageLibraryLink =""  } = param;
    const activeTabData = (0,react.useRef)(null);
    const sanitizeText = (text)=>{
        var ref, ref1, ref2, ref3, ref4, ref5, ref6;
        if (!text) return "";
        return (ref6 = (ref5 = (ref4 = (ref3 = (ref2 = (ref1 = (ref = text === null || text === void 0 ? void 0 : text.replace(/<[^>]*>/g, "") // Remove HTML tags
        ) === null || ref === void 0 ? void 0 : ref.replace(/&amp;/g, "&") // Convert &amp; to &
        ) === null || ref1 === void 0 ? void 0 : ref1.replace(/&lt;/g, "<") // Convert &lt; to <
        ) === null || ref2 === void 0 ? void 0 : ref2.replace(/&gt;/g, ">") // Convert &gt; to >
        ) === null || ref3 === void 0 ? void 0 : ref3.replace(/&quot;/g, '"') // Convert &quot; to "
        ) === null || ref4 === void 0 ? void 0 : ref4.replace(/&#039;/g, "'") // Convert &#039; to '
        ) === null || ref5 === void 0 ? void 0 : ref5.replace(/&#39;/g, "'") // Convert &#39; to '
        ) === null || ref6 === void 0 ? void 0 : ref6.trim();
    };
    const tabList = [
        {
            title: i18n.pressRelease,
            content: /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_TabContent, {
                analyticsLabel: "press releases",
                i18n: i18n,
                pressContact: pressContact,
                productPlacement: productPlacement,
                tabData: /*#__PURE__*/ (0,jsx_runtime.jsx)(PressRoomView_PressRelease, {
                    i18n: i18n,
                    refData: activeTabData
                })
            })
        },
        {
            title: i18n.pressKit,
            content: /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_TabContent, {
                analyticsLabel: "press kits",
                i18n: i18n,
                pressContact: pressContact,
                productPlacement: productPlacement,
                tabData: /*#__PURE__*/ (0,jsx_runtime.jsx)(PressKit_view, {
                    i18n: i18n,
                    refData: activeTabData
                })
            })
        },
        {
            title: i18n.imageLibrary,
            url: imageLibraryLink
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (index_module_default()).myRoomViewWrapper,
        id: "press-room-as",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
            tabIndex: "-1",
            className: "press-room",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container-fluid press-room__header",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "kf-react-container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "row press-room__main-row",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-8 col-md-8 press-room__title-block",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                        className: "press-room__title",
                                        children: title
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-4 col-md-4 press-room__description-block",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "press-room__description",
                                        children: sanitizeText(desc)
                                    })
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_TabComponent, {
                    i18n: i18n,
                    tabList: tabList,
                    refData: activeTabData
                })
            ]
        })
    });
};
/* harmony default export */ var v1_PressRoomView = (PressRoomView);

;// CONCATENATED MODULE: ./src/components/PressRoomLanding/v1/PressRoomLanding/index.jsx





const PressRoom = (props)=>{
    const { data: authorData  } = props;
    const staticTexts = i18n_usePressLandingi18n({
        authorData
    });
    const [state] = (0,react.useState)({
        imageLibraryLink: "",
        title: "",
        description: "",
        pressItems: [],
        productItems: [],
        rows: lib/* isMobile */.tq ? 30 : sessionStorage.getItem("rows") || 30,
        start: 0,
        ...authorData
    });
    const { imageLibraryLink , title , description , pressItems , productItems  } = state;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_PressRoomView, {
            i18n: staticTexts,
            imageLibraryLink: imageLibraryLink,
            title: title,
            desc: description,
            pressContact: pressItems,
            productPlacement: productItems
        })
    });
};
/* harmony default export */ var PressRoomLanding = (PressRoom);

;// CONCATENATED MODULE: ./src/pages/press-room.jsx










const press_room_PressRoom = (param)=>{
    let { tmpData: data , headertmp: header , footertmp: footer , ip , globalScript , footerScript , analyticsData , datalayerPageName , gbhDataLayerCustom  } = param;
    (0,react.useEffect)(()=>{
        (0,helper/* getDataLayerObj */.C2G)(analyticsData);
    }, [
        analyticsData
    ]);
    const dispatch = (0,es/* useDispatch */.I0)();
    (0,react.useEffect)(()=>{
        dispatch((0,genericSlice/* setDatalayerPageName */.dN)(datalayerPageName));
        dispatch((0,genericSlice/* setGbhDataLayerCustom */.ks)(gbhDataLayerCustom));
        return ()=>{
            dispatch((0,genericSlice/* setDatalayerPageName */.dN)(""));
            dispatch((0,genericSlice/* setGbhDataLayerCustom */.ks)(""));
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalPageLayout/* default */.Z, {
        header: /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalPageHeader/* default */.Z, {
            header: header,
            title: data.title,
            globalScripting: globalScript
        }),
        footer: /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalPageFooter/* default */.Z, {
            footer: footer,
            footerScripting: footerScript
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AemGrid/* default */.Z, {
            data: data,
            count: 0,
            pressReleaseLanding: (data)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(PressRoomLanding, {
                    data: data
                })
        })
    });
};
var __N_SSP = true;
/* harmony default export */ var press_room = (press_room_PressRoom);


/***/ }),

/***/ 7805:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"myKitViewWrapper":"PressKit_view_myKitViewWrapper__C8NbS"};

/***/ }),

/***/ 2681:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"myRoomViewWrapper":"PressRoomView_myRoomViewWrapper__H195E"};

/***/ }),

/***/ 48162:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"accordionWrapper":"Accordion_accordionWrapper__q7CiR"};

/***/ }),

/***/ 25043:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ g; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var h = Object.defineProperty;
var u = (n, t, e) => t in n ? h(n, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : n[t] = e;
var c = (n, t, e) => (u(n, typeof t != "symbol" ? t + "" : t, e), e);

const p = (n, t) => typeof getComputedStyle < "u" ? getComputedStyle(n, null).getPropertyValue(t) : n.style.getPropertyValue(t), y = (n) => p(n, "overflow") + p(n, "overflow-y") + p(n, "overflow-x"), w = (n) => {
  if (!(n instanceof HTMLElement))
    return window;
  let t = n;
  for (; t && !(t === document.body || t === document.documentElement || !t.parentNode); ) {
    if (/(scroll|auto)/.test(y(t)))
      return t;
    t = t.parentNode;
  }
  return window;
};
class g extends react__WEBPACK_IMPORTED_MODULE_0__.Component {
  constructor(e) {
    super(e);
    c(this, "elementObserver");
    c(this, "wrapper");
    c(this, "lazyLoadHandler", (e) => {
      var o, i;
      const {
        onContentVisible: s
      } = this.props, [r] = e, {
        isIntersecting: l
      } = r;
      if (l) {
        this.setState({
          visible: !0
        }, () => {
          s && s();
        });
        const a = (o = this.wrapper) == null ? void 0 : o.current;
        a && a instanceof HTMLElement && ((i = this.elementObserver) == null || i.unobserve(a));
      }
    });
    this.elementObserver = null, this.wrapper = react__WEBPACK_IMPORTED_MODULE_0__.createRef(), this.state = {
      visible: !1
    };
  }
  componentDidMount() {
    var o;
    this.getEventNode();
    const {
      offset: e,
      threshold: s
    } = this.props, r = {
      rootMargin: typeof e == "number" ? `${e}px` : e || "0px",
      threshold: s || 0
    };
    this.elementObserver = new IntersectionObserver(this.lazyLoadHandler, r);
    const l = (o = this.wrapper) == null ? void 0 : o.current;
    l instanceof HTMLElement && this.elementObserver.observe(l);
  }
  shouldComponentUpdate(e, s) {
    return s.visible;
  }
  componentWillUnmount() {
    var s, r;
    const e = (s = this.wrapper) == null ? void 0 : s.current;
    e && e instanceof HTMLElement && ((r = this.elementObserver) == null || r.unobserve(e));
  }
  getEventNode() {
    var e;
    return w((e = this.wrapper) == null ? void 0 : e.current);
  }
  render() {
    const {
      children: e,
      className: s,
      height: r,
      width: l,
      elementType: o
    } = this.props, {
      visible: i
    } = this.state, a = {
      height: r,
      width: l
    }, d = `LazyLoad${i ? " is-visible" : ""}${s ? ` ${s}` : ""}`;
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(o || "div", {
      className: d,
      style: a,
      ref: this.wrapper
    }, i && react__WEBPACK_IMPORTED_MODULE_0__.Children.only(e));
  }
}
c(g, "defaultProps", {
  elementType: "div",
  className: "",
  offset: 0,
  threshold: 0,
  width: null,
  onContentVisible: null,
  height: null
});



/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3662,6351,6342,4432,7333,4904,361,3574,5921,6344,4607,2634,9450,9774,2888,179], function() { return __webpack_exec__(42512); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);